<script>
  import { navigate } from 'svelte-navigator'
  import { _ } from 'svelte-i18n'

  import Link from '/Atoms/Link'
  import Body from '/Groups/Body'
  import IconClose from '/components/Icons/IconCloseBlur'
  import Preconditions from '/Groups/ArtworkPreconditions/Preconditions'

  export let data

  const item = data?.gallery || {}

  const title = item?.title
  const subtitle = item?.relatedPeople?.[0]?.members
    ?.map((member) => member.title)
    .join(', ')
  const translator = item?.translator
  const type = item?.textMediaCategory

  // first 12 blocks contain the assets
  const assetBlocks = item?.body?.slice(0,12) 
  // 13th block contains description
  const body = item?.body?.slice(12,13)
  // blocks 14 to 26 contain texts
  const textBlocks = item?.body?.slice(13, 25)

</script>

<section class="almanac-item">
  <div class="close">
    <div class="close-icon">
      <Link to="/almanac">
        <IconClose />
      </Link>
    </div>
  </div>

  <div class="content">
    {#if type}
      <h2 class="category">
        {type}
      </h2>
    {/if}
    {#if title || subtitle || translator}
      <div class="header">
        <h1 class="title">{title}</h1>
        <!--
          {#if subtitle}
            <h3 class="subtitle">{subtitle}</h3>
          {/if}
          {#if translator}
            <h3 class="subtitle translator">{translator}</h3>
          {/if}
        -->
      </div>
    {/if}
  </div>
  {#if assetBlocks && textBlocks}
    <Preconditions {assetBlocks} {textBlocks} />
  {/if}

  <div class="content">
    <Body {body} />
  </div>
</section>

<style lang="scss">
  section {
    height: 100vh;
    background-color: $color-beige;
    overflow-y: scroll;
    position: relative;
    text-align: center;

    //@include grid;
    //@include grid-padding;

    .close {
      @include grid-dist('right');
      /*isolation: isolate;*/
      /*position: sticky;*/
      position: fixed;
      top: 0;
      left: calc(100vw - 85px - #{$grid-gap-large});
      @include media-small {
        transform-origin: 90% 10%; // not a good asset
        transform: scale(0.8);
      }
      .close-icon {
        cursor: pointer;
      }
    }
    .content {
      //grid-column: 3 / span 8;
      display: inline-block;
      max-width: 1440px;
      margin: auto;
      box-sizing: border-box;
      //border: dashed 1px rgba(0,255,255,1);

      margin-left: 40px;
      margin-right: 40px;

      .header h1.title {
        font-size: 3.2vw;
        @media screen and (min-width: 800px) {
          font-size: 26px;
        }
      }

      @include media-1col-only {
        margin-left: 20px;
        margin-right: 20px;
      }

      @include media-large-only {
        padding-left: 40px;
        padding-right: 40px;
        // note: images don't have this padding
      }

      margin-top: 88px;
      margin-bottom: 35px + $audioplayer-height;
    }
  }

  .category {
    @include typo-serif-small-caps-28;
    color: $color-red;
    margin-bottom: 32px;
  }

  .header {
    margin-bottom: 30px;
  }

  .title {
    @include typo-grotesk-title-50;
  }

  .subtitle {
    @include typo-grotesk-title-30;
    &.translator {
      @include typo-grotesk-text-24;
    }
  }

  .title + .subtitle {
    margin-top: 8px;
  }
</style>
